import { gql } from '@apollo/client'

export const GET_GLOBALIZER_FEEDS_BY_CAMPAIGN_ID = gql`
  query getGlobalizerFeedsByCampaignId($campaignId: String!, $offset: Int, $limit: Int, $filter: [FeedTagFilter]) {
    getGlobalizerFeedsByCampaignId(campaignId: $campaignId, offset: $offset, limit: $limit, filter: $filter) {
      feeds {
        id
        gallery
        comments {
          id
          author_id
          author {
            first_name
            last_name
            label_id
          }
          campaign_id
          created_at
          updated_at
          text
          argument_id
        }
        title
        body
        created_at
        editable
        global_status
        tags {
          id
          label
          order_number
        }
        author {
          last_name
          first_name
          email
        }
        campaign {
          id
          name
          owner_id
          artist {
            name
            facebook_id
            spotify_id
          }
        }
        artist {
          name
          spotify_id
          facebook_id
        }
        lastEditor {
          last_name
          first_name
          email
        }
        updated_at
      }
      total
    }
  }
`
